module.exports = __webpack_public_path__ + "img/horizontal_3_2_3009.63740ba4.png";